(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('virtualFairsTotalStudentController', virtualFairsTotalStudentController);
    virtualFairsTotalStudentController.$inject = ['$scope', 'VirtualFairService', 'DTOptionsBuilder', 'virtualfairs', 'isPlatformRental'];

    function virtualFairsTotalStudentController($scope, VirtualFairService, DTOptionsBuilder, virtualfairs, isPlatformRental) {
        var vm = this;
        vm.flag                    = false;
        vm.gpData                  = [];
        vm.typeSelected            = -1;
        vm.types                   = [{name:'All', id:-1},{name:'Confirmed', id:1},{name:'Pending', id:0}, {name : 'Attended', id : 2}];
        vm.result                  = [];
        vm.virtualFairs            = [];
        vm.virtualFairSelected     = '';
        vm.getByFilter             = getByFilter;
        vm.getAllVirtualFair       = getAllVirtualFair;
        vm.percentage              = percentage;
        vm.formatAreaXLabel        = formatAreaXLabel;
        vm.formatAreaYLabel        = formatAreaYLabel;
        vm.virtualFairs            = virtualfairs;
        vm.formatPercent           = formatPercent;
        vm.downloadCSV             = downloadCSV;
        vm.isPlatformRental        = isPlatformRental;
        vm.canDownloadCsv          = false;

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('paging', false)
            .withOption('info', false);

        function active() {
            vm.getAllVirtualFair();
            if(!isPlatformRental) {
                vm.canDownloadCsv = true;
            } else {
                var user = localStorage.getItem('user');
                vm.canDownloadCsv = JSON.parse(user).can_download_csv;
            }
        }

        function getByFilter() {
            var query = [];
            query['virtual_fair'] = vm.virtualFairSelected;
            if(vm.typeSelected != -1) {
                query['type'] = vm.typeSelected;
            }
            VirtualFairService.getByTotalStudents(query, vm.isPlatformRental).then(function(response) {
                vm.flag = true;
                response.data.registration_interval = response.data.registration_interval.slice().reverse()
                vm.result = response.data;
                vm.gpData = response.data;
            }).catch(function(err) {

            });
        }

        function getAllVirtualFair() {
            // if(!vm.isPlatformRental) {
                if(!vm.virtualFairs) {
                    VirtualFairService.getAll(vm.isPlatformRental).then(function(response) {
                        vm.virtualFairs = response.data;
                    }).catch(function(err) {
                    });
                }
            // }
        }

        function percentage(total, qtd)
        {
            if(qtd > 0 && total > 0){
                return ((parseInt(qtd) / parseInt(total))*100).toFixed(2);
            }
            return 0;
        }
        function formatAreaXLabel(input) {
            return (input.src.x).toString();
        }

        function formatAreaYLabel(input) {
            return parseInt(input);
        }

        function formatPercent(input) {
            return input + '%';
        }
        
        function downloadCSV() {
            vm.disableDownloadCsv = true;
            let query = {};
            query['virtual_fair_id'] = vm.virtualFairSelected;
            if(vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }
            if(vm.typeSelected != -1) {
                query['type'] = vm.typeSelected;
            }
            VirtualFairService.leadsCSV(vm.virtualFairSelected, query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `virtual_fair_leads_${vm.virtualFairSelected}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              vm.disableDownloadCsv = false;
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }

        active();
    }
})();